import { useContext, useEffect, useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import ItsoTables from './childcomponents/itsotables';
import ItsoOutputTables from './childcomponents/itsooutputtables';
import { useAppDispatch } from '../../stores/hooks';
import { setcurrentmenu } from '../../stores/menuslice';
import Logs from '../../shared/datamanagementcomponents/log';
import { TabPanel,a11yProps,TabPanelProps } from '../../shared/childcomponents/TabPanels';
import { IsEditedContext } from '../../../App';
import ConfirmDialog from '../../shared/confirmdialog';

export default function ITSO() {
  const [value, setValue] = useState(0);
  const dispatch = useAppDispatch();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const [pendingTab, setPendingTab] = useState<number | null>(null);
  const { isEdited, setIsEdited } = useContext(IsEditedContext);
  useEffect(() => {
    // document.title = `Hello ${name}`;
    dispatch(setcurrentmenu('itso'));
  },[] )

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (isEdited) {
           
      setConfirmDialogOpen(true); 
      setPendingTab(newValue); 
    } else {
      setValue(newValue);
    }
   
  };
  const handleDialogCallback = (confirmed: boolean) => {
    setConfirmDialogOpen(false);
   
    if (!confirmed && pendingTab) {
        setIsEdited(false);
        setValue(pendingTab);
    }
    setPendingTab(null); 
  };
  return (
    <Box sx={{ width: '100%',p:1 }}>
       <ConfirmDialog
        isopen={confirmDialogOpen}
        title="Unsaved Changes"
        message="Are you sure you want to continue? Any unsaved changes will be lost."
        needComments={false}
        callback={handleDialogCallback}
        yesButtonText="Stay and Save"
        cancelButtonText="Continue"
      />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} variant="fullWidth" aria-label="basic tabs example">
          <Tab label="Data Management" {...a11yProps(0)} />
          <Tab label="Output Tables" {...a11yProps(1)} />
          <Tab label="Logs" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <ItsoTables />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ItsoOutputTables/>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Logs parent='itso'/>
      </TabPanel>
    </Box>
  );
}